/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {
    RouterModule,
    Routes
} from '@angular/router';
import {RoutingMenuItemModel} from '../shared/utils/routing-menu-item.model';
import {PermissionsGuard} from '../permissions.guard';
import {SettlementsMainPageComponent} from './settlements-main-page/settlements-main-page.component';
import {FeatureToggleGuard} from '../shared/guards/feature-toggle/feature-toggle.guard';
import {Permission} from '../shared/utils/permission.enum';
import {NeverActivateRouting} from '../never-activate-routing';

export const routes: Routes = [
    {
        path: 'settlements',
        canActivate: [FeatureToggleGuard, PermissionsGuard],
        canActivateChild: [FeatureToggleGuard, PermissionsGuard],
        data: {
            hasSideBarMenu: true,
            breadcrumb: 'Complaint Settlements',
            permissions: [Permission.ADMIN_SETTLEMENT_VIEW, Permission.SUPPLIER_SETTLEMENT_VIEW, Permission.FOUR_EYES_SETTLEMENT_VIEW],
            featureToggles: ['feature.toggle.settlements'],
            menuItem: {
                label: 'Complaint Settlements',
                icon: 'iwp-icon-ci_like',
                index: 4
            } as RoutingMenuItemModel
        },
        children: [
            {
                path: '',
                canActivate: [NeverActivateRouting],
                redirectTo: '',
                pathMatch: 'full'
            },
            {
                path: 'supplier',
                component: SettlementsMainPageComponent,
                data: {
                    breadcrumb: 'Supplier list',
                    hasSideBarMenu: true,
                    hasStickyHeader: true,
                    permissions: [Permission.ADMIN_SETTLEMENT_VIEW, Permission.SUPPLIER_SETTLEMENT_VIEW],
                    businessConfiguration: 'supplier',
                    menuItem: {
                        label: 'Supplier list'
                    } as RoutingMenuItemModel
                }
            },
            {
                path: 'customer',
                component: SettlementsMainPageComponent,
                data: {
                    breadcrumb: 'Customer list',
                    hasSideBarMenu: true,
                    hasStickyHeader: true,
                    permissions: [Permission.ADMIN_SETTLEMENT_VIEW, Permission.FOUR_EYES_SETTLEMENT_VIEW],
                    businessConfiguration: 'customer',
                    menuItem: {
                        label: 'Customer list'
                    } as RoutingMenuItemModel
                }
            }
        ]
    }

];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SettlementsRoutingModule {
}
